import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import { styled } from '@mui/material/styles';
import * as S from './styles'

/* ===== DOT ===== */
const Dot = styled('div')({
  margin: '12px 0',
  height: 'fit-content',

  '& p': {
    fontFamily: 'Open Sans',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '32px',
    textAlign: 'center',
    letterSpacing: 0,
    marginBottom: '5px'
  },
});

const CustomDot = styled('div')({
  width: 74,
  height: 74,
  borderRadius: "100%",
  padding: 12,
  display: 'grid',
  placeItems: 'center',
  position: 'relative',
  background: '#1a1f2a',
  isolation: 'isolate',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '50%',
    backgroundColor: "var( --color-1D1D1D)",
    zIndex: -1,
  },
});

/* ===== ÍCONE ===== */
const DotIcon = styled('div')({
  width: '100%',
  height: '100%',
  display: 'grid',
  placeItems: 'center',
  color: '#b46cff',
  opacity: 0.95,
  img: {
    width: '70%',
    height: '70%',
    objectFit: 'contain',
  },
});

/* ===== CONECTOR SÓLIDO ===== */
const SolidConnector = styled(TimelineConnector)({
  width: 2,
  background:
    'linear-gradient(180deg, rgba(255,255,255,.45) 0%, rgba(255,255,255,.2) 100%)',
});

/* ===== CENTRALIZAÇÃO ===== */
const CenterSeparator = styled(TimelineSeparator)({
  alignItems: 'center',
});

/**
 * @param {{ items: Array<{year?: string, title?: string, text?: string, icon?: string|React.ReactNode}> }} props
 */
export function AlternateTimeline({ items = [] }) {
  return (
    <div>
      <S.Mobile>
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <div style={{
              display: 'flex',
              gap: '16px',
              alignItems: 'center'
            }}>
              <Dot >
                <p>{item.year}</p>
                <CustomDot >
                  <DotIcon>
                    {typeof item.icon === 'string' ? (
                      <img src={item.icon} alt={item.title || ''} />
                    ) : (
                      item.icon
                    )}
                  </DotIcon>
                </CustomDot>
              </Dot>


              <S.Card>
                <div className="module">
                  <div className="colors blue" />
                  <div className="colors pink" />


                  <S.CardTitle>{item.title}</S.CardTitle>

                  <S.CardBody>{item.text}</S.CardBody>

                </div>
              </S.Card>
            </div>
          );
        })}

      </S.Mobile>


      <S.Desk>
        <Timeline
          position="alternate"
          sx={{ m: 0, p: 0 }}
          style={{
            maxWidth: '1000px'
          }}
        >
          {items.map((item, idx) => {
            const isLast = idx === items.length - 1;
            return (
              <TimelineItem key={idx} sx={{ minHeight: 180 }}>
                <CenterSeparator>
                  <Dot >
                    <p>{item.year}</p>
                    <CustomDot >
                      <DotIcon>
                        {typeof item.icon === 'string' ? (
                          <img src={item.icon} alt={item.title || ''} />
                        ) : (
                          item.icon
                        )}
                      </DotIcon>
                    </CustomDot>
                  </Dot>
                  {!isLast && <SolidConnector />}
                </CenterSeparator>

                <TimelineContent
                  style={{
                    width: 'fit-content',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                  <S.Card>
                    <div className="module">
                      <div className="colors blue" />
                      <div className="colors pink" />


                      <S.CardTitle>{item.title}</S.CardTitle>

                      <S.CardBody>{item.text}</S.CardBody>

                    </div>
                  </S.Card>

                </TimelineContent>
              </TimelineItem>
            );
          })}
        </Timeline >
      </S.Desk>
    </div >
  );
}
